import { MenuItem, Select, SelectChangeEvent, Slider, Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import SectionHeader from "./Components/SectionHeader";
import FilterBox from "./Components/FilterBox";
import { OtherFilters } from "../../../types";
import { OverviewIcon, ProfessionalInfoIcon } from "../../../assets/icons/MUI/AdvancedSearch";
import { useTranslation } from "react-i18next";

const OtherFilter = ({
  advancedFilters,
  setAdvancedFilters,
  isFilterCleared,
}: {
  advancedFilters: OtherFilters;
  setAdvancedFilters: React.Dispatch<React.SetStateAction<OtherFilters>>;
  isFilterCleared: boolean;
}) => {
  const { t } = useTranslation();

  const position = [
    { value: "", label: t("components.networkController.advancedFilterPopUp.chooseAreas") },
    { value: "FOOTBALL_REFEREE", label: t("enums.persona.role.FOOTBALL_REFEREE") },
    { value: "FOOTBALL_FAN", label: t("enums.persona.role.FOOTBALL_FAN") },
    { value: "SPORTS_COMMENTATOR", label: t("enums.persona.role.SPORTS_COMMENTATOR") },
    { value: "SPORTS_BROADCASTER", label: t("enums.persona.role.SPORTS_BROADCASTER") },
    { value: "SPORTS_JOURNALIST", label: t("enums.persona.role.SPORTS_JOURNALIST") },
    { value: "FOOTBALL_PERFORMANCE_ANALYST", label: t("enums.persona.role.FOOTBALL_PERFORMANCE_ANALYST") },
    { value: "FOOTBALL_ANALYST", label: t("enums.persona.role.FOOTBALL_ANALYST") },
    { value: "TEAM_PHYSICIAN", label: t("enums.persona.role.TEAM_PHYSICIAN") },
    { value: "FITNESS_COACH", label: t("enums.persona.role.FITNESS_COACH") },
    { value: "PHYSIOTHERAPIST", label: t("enums.persona.role.PHYSIOTHERAPIST") },
    { value: "NUTRITIONIST", label: t("enums.persona.role.NUTRITIONIST") },
    { value: "FOOTBALL_CLUB_GENERAL_MANAGER", label: t("enums.persona.role.FOOTBALL_CLUB_GENERAL_MANAGER") },
    { value: "FOOTBALL_CLUB_DIRECTOR", label: t("enums.persona.role.FOOTBALL_CLUB_DIRECTOR") },
    { value: "FOOTBALL_CLUB_OWNER", label: t("enums.persona.role.FOOTBALL_CLUB_OWNER") },
    { value: "FOOTBALL_MANAGER", label: t("enums.persona.role.FOOTBALL_MANAGER") },
    { value: "SPORTS_WRITER", label: t("enums.persona.role.SPORTS_WRITER") },
    { value: "SPORTS_EVENT_COORDINATOR", label: t("enums.persona.role.SPORTS_EVENT_COORDINATOR") },
    { value: "OTHER", label: t("enums.persona.role.OTHER") },
    { value: "ENTITY_ADMIN", label: t("enums.persona.role.ENTITY_ADMIN") },
  ];

  const initialFilters = {
    position: advancedFilters.position || "",
    experienceRange: (advancedFilters.experienceRange as [number, number]) || [1, 40],
    hasCertificateOrLicense: advancedFilters.hasCertificateOrLicense || false,
  };

  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    setAdvancedFilters(filters);
  }, [filters]);

  useEffect(() => {
    setFilters(initialFilters);
  }, [isFilterCleared]);

  type FilterKeys = keyof typeof filters;

  const handleSliderChange = (name: FilterKeys) => (event: Event, newValue: number | number[]) => {
    setFilters((prevState) => ({ ...prevState, [name]: newValue }));
  };

  const handleSwitchChange = (name: FilterKeys) => () => {
    setFilters((prevState) => ({ ...prevState, [name]: !prevState[name] }));
  };

  return (
    <>
      <SectionHeader icon={OverviewIcon} title={t("components.networkController.advancedFilterPopUp.otherOverview")} />
      <FilterBox label={t("components.networkController.advancedFilterPopUp.position")}>
        <Select
          value={filters.position}
          onChange={(event: SelectChangeEvent) =>
            setFilters((prevState) => ({
              ...prevState,
              position: event.target.value as string,
            }))
          }
          displayEmpty
          sx={{ minWidth: "160px" }}
        >
          {position.map((position) => (
            <MenuItem key={position.value} value={position.value}>
              {position.label}
            </MenuItem>
          ))}
        </Select>
      </FilterBox>
      <FilterBox label={t("components.networkController.advancedFilterPopUp.experienceRange")}>
        <Slider
          value={filters.experienceRange}
          onChange={handleSliderChange("experienceRange")}
          valueLabelDisplay="auto"
          sx={{ maxWidth: "360px", width: "50%" }}
          min={1}
          max={40}
        />
      </FilterBox>
      <SectionHeader
        icon={ProfessionalInfoIcon}
        title={t("components.networkController.advancedFilterPopUp.professionalInfo")}
      />
      <FilterBox label={t("components.networkController.advancedFilterPopUp.hasFootballExperience")}>
        <Switch checked={filters.hasCertificateOrLicense} onChange={handleSwitchChange("hasCertificateOrLicense")} />
      </FilterBox>
    </>
  );
};

export default OtherFilter;
